import React from "react";

const Data = () => {
  return (
    <div className="home__data">
      <h1 className="home__title">Komal Reddy👋🏻
      </h1>
      <h3 className="home__subtitle">Programmer</h3>
      <p className="home__description" style={{textAlign:'justify'}}>Software Engineer @Appzoy, Graduated from NIT Manipur with B.Tech in Computer Science and Engineering</p>

      <a href="#contact" className="button button--flex">
        Say Hi
        
      </a>
    </div>
  );
};

export default Data;
